export default __webpack_public_path__ + "04edb09858a35a56084565cbd1afcce5.jpg";